import { gql } from '@apollo/client'

import { FRAGMENT as VIDEO_FRAGMENT } from '../../components/LibraryPostVideoCard'
import { FRAGMENT as ARTICLE_FRAGMENT } from '../../components/LibraryPostArticleCard'

export const PAGES = gql`
  query GuidePages {
    libraryGuides {
      nodes {
        id
        slug
      }
    }
  }
`

export const GUIDE = gql`
  query Guide($slug: String!) {
    libraryGuide(slug: $slug) {
      mailchimpTag
      seoDescription
      description
      downloadUrl
      id
      color
      image {
        url
        blurhash
      }
      posts {
        ... on LibraryPostArticle {
          ...LibraryPostArticleCardComponent
        }
        ... on LibraryPostVideo {
          ...LibraryPostVideoCardComponent
        }
      }
      overview
      slug
      title
    }
  }

  ${VIDEO_FRAGMENT}
  ${ARTICLE_FRAGMENT}
`
